<template>
  <div class="w-50 p-3 mx-auto mt-4">
    <h1 class="mt-4 mb-4 text-center">
      Ajouter un nouvel attribut MIRAKL
    </h1>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-card>
        <b-card-body>
          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-group
              label-cols="7"
              label-cols-lg="5"
              label-size="small"
              label="Label attribut MIRAKL"
              label-for="categories"
            >
              <b-form-input
                id="categories"
                v-model="form.label"
                :state="getValidationState(validationContext)"
                aria-describedby="categories-mirakl-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="categories-mirakl-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-group
              label-cols="7"
              label-cols-lg="5"
              label-size="small"
              label="Code unique"
              label-for="code"
            >
              <b-form-input
                id="code"
                v-model="form.code"
                :state="getValidationState(validationContext)"
                aria-describedby="code-mirakl-feedback"
                aria-required="true"
              ></b-form-input>
              <b-form-invalid-feedback id="code-mirakl-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <b-form-group
            label="Description"
            label-for="description"
            label-cols="7"
            label-cols-lg="5"
          >
            <b-form-textarea
              id="description"
              rows="3"
              max-rows="6"
              v-model="form.description"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            label="Type"
            label-for="type"
            label-cols="7"
            label-cols-lg="5"
          >
            <b-form-select
              id="type"
              :options="[
                'TEXT',
                'LONG_TEXT',
                'MEDIA',
                'DATE',
                'INTEGER',
                'DECIMAL',
                'LIST',
                'LIST_MULTIPLE_VALUES',
                'MULTIPLE',
                'MEASUREMENT'
              ]"
              v-model="form.type"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            label-cols="7"
            label-cols-lg="5"
            label-size="small"
            label="Type de paramètre"
            label-for="parameter"
          >
            <b-form-input
              id="parameter"
              v-model="form.typeParameters"
            ></b-form-input>
          </b-form-group>
        </b-card-body>
        <div class="text-right">
          <gwz-button
            submitButtonText="Valider"
            @click="handleSubmit(onSubmit)"
          />
          <b-button variant="secondary" class="m-2" @click="cancel"
            >Annuler</b-button
          >
        </div>
      </b-card>
    </ValidationObserver>
  </div>
</template>

<script>
import gwzAutoComplete from "@/components/gwzAutoComplete";
import { required } from "vee-validate/dist/rules";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import GwzButton from "@/components/gwzButton";
import { mapGetters, mapActions } from "vuex";
import { cateRowMixin } from "@/mixins/attributes";

// Override the default message.
extend("required", {
  ...required,
  message: "Ce champ est obligatoire"
});
export default {
  name: "AddAttribut",
  mixins: [cateRowMixin],
  components: {
    GwzButton,
    // eslint-disable-next-line vue/no-unused-components
    gwzAutoComplete,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      form: {
        label: "",
        description: "",
        type: "",
        typeParameters: "",
        code: "",
        variant: "",
        transformations: "",
        validations: ""
      },
      validationContext: {}
    };
  },
  computed: {
    ...mapGetters(["isError"])
  },
  methods: {
    ...mapActions(["setErrors"]),
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async onSubmit() {
      await this.$store.dispatch("attributes/addAttribute", this.form);
      (await this.isError)
        ? this.reset()
        : this.$router.push({ name: "Attributes" });
    },
    reset() {
      this.form.code = "";
      this.setErrors(false);
    },
    cancel() {
      this.$router.push({ name: "Attributes" });
    }
  }
};
</script>
